<template>
  <div>
    <v-container class="py-12">
      <v-card elevation="6" rounded="xl" class="pa-6">
        <v-card-title class="text-h4 font-weight-bold mb-4">
          Terms and Conditions
        </v-card-title>
        <v-card-text class="text-body-1">
          <!-- Loading State -->
          <div v-if="isLoading" class="text-center py-8">
            <v-progress-circular
              indeterminate
              color="primary"
              size="50"
            ></v-progress-circular>
            <p class="mt-4">Loading Terms and Conditions...</p>
          </div>

          <!-- Content from API -->
          <div
            v-else-if="companyData && companyData.terms_conditions"
            v-html="companyData.terms_conditions"
            class="terms-content"
          ></div>

          <!-- Fallback if no content -->
          <div v-else class="text-center py-8">
            <v-icon size="64" color="grey lighten-1">mdi-file-document-outline</v-icon>
            <p class="mt-4 grey--text">Terms and Conditions content is not available.</p>
          </div>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "TermsAndConditions",
  data() {
    return {
      companyData: null,
      isLoading: false,
    };
  },
  mounted() {
    this.getCompanyData();
  },
  methods: {
    async getCompanyData() {
      this.isLoading = true;
      try {
        const companyId = this.company?.id || this.user?.companies?.[0]?.id;
        if (companyId) {
          const response = await axios.get(`/companies/${this.encryptIt(companyId)}`);
          this.companyData = response.data.data;
        }
      } catch (error) {
        console.error("Error fetching company data:", error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.terms-content {
  line-height: 1.8;
}

.terms-content >>> h1,
.terms-content >>> h2,
.terms-content >>> h3,
.terms-content >>> h4,
.terms-content >>> h5,
.terms-content >>> h6 {
  margin-top: 1.5rem;
  margin-bottom: 0.75rem;
  font-weight: bold;
}

.terms-content >>> p {
  margin-bottom: 1rem;
  line-height: 1.6;
}

.terms-content >>> ul,
.terms-content >>> ol {
  padding-left: 1.5rem;
  margin-bottom: 1rem;
}

.terms-content >>> li {
  margin-bottom: 0.5rem;
}

.terms-content >>> a {
  color: #1976d2;
  text-decoration: none;
}

.terms-content >>> a:hover {
  text-decoration: underline;
}
</style>
